<script>
	import PageSection from "../../components/PageSection.svelte";
	import FormRow from "../../components/FormRow.svelte";
	import FormColumn from "../../components/FormColumn.svelte";
	import ClassActionPhoneNumber from "../../components/ClassActionPhoneNumber.svelte";
	import ClassActionEmailAddress from "../../components/ClassActionEmailAddress.svelte";
	import { projectSettings } from "../../config";
	export let pageTitle = null;
	document.title = pageTitle;
	window.onbeforeunload = null;
</script>

<PageSection>
	<FormRow class="justify-content-center">
		<FormColumn>
			<h1 class="text-center">{@html projectSettings.classActionName}</h1>
			<h2 class="text-center">
				Your registration form for the {@html projectSettings.classActionName}
				has already been completed.
			</h2>
		</FormColumn>
	</FormRow>
	<FormRow>
		<FormColumn>
			<h3>Your reference number</h3>
			<div class="box">{window.registrationNumber}</div>
			<p>
				If you have any questions or would like to change any of your responses, please contact Shine Lawyers on
				<ClassActionPhoneNumber></ClassActionPhoneNumber>, or at <ClassActionEmailAddress
				></ClassActionEmailAddress> and quote the registration number above.
			</p>
		</FormColumn>
	</FormRow>
</PageSection>

<style>
	.box {
		background-color: var(--color-white);
		border: solid 1px var(--color-border);
		border-radius: 1px;
		padding: var(--spacing-sm);
		transition: var(--transition-fast);
		height: 50px;
		font-size: 18px;
		line-height: 26px;
		color: var(--color-body);
	}
</style>
